<template>
    <Head title="Como Ganhar" />

    <AuthenticatedLayout>
        <HeaderComponent :showExtras="false" />
            <div class="flex-center">
                <Heading title="Como Ganhar" class="xl:px-[15.5vw] sm:px-6 pt-24"/>
                    <div class="pt-6 xl:pt-8 pb-[35px] xl:px-[15.5vw] px-4 rounded-[4px]">
                        <div class="xl:hidden">
                            <img src="images/mobile/how_it_works_header.png" alt="Como Funciona">
                        </div>
                        <div class="sm:hidden">
                            <img src="images/desktop/how_it_works_header.png" alt="Como Funciona">
                        </div>
                            <div class="flex flex-col gap-y-9 my-3">
                                <TitleDescription title="Nome da campanha" :class="`text-black`" :description="campaign.name" />
                                <TitleDescription title="Descrição" :class="`text-black`" :description="campaign.description" />
                                <TitleDescription title="Duração do período" :class="`text-black`" :description="period()" />
                                <section>
                                    <TitleDescription title="Mecânica" />
                                    <div class="xl:hidden">
                                        <img src="images/mobile/how_it_works_mechanics.png" alt="Mecânica">
                                    </div>
                                    <div class="sm:hidden">
                                        <img src="images/desktop/how_it_works_mechanics.png" alt="Mecânica">
                                    </div>
                                </section>
                            </div>
                            <div class="flex flex-col gap-y-2.5 my-5">
                                <TitleDescription title="Regulamento" :class="`text-black`" description="Entenda como funciona a campanha." />
                                <Button @click="href('regulation')" class="max-w-[182px] whitespace-nowrap text-primary border border-primary !bg-white hover:!bg-gray-300 hover:border-gray-300">
                                    Ler o Regulamento
                                </Button>
                            </div>
                                <!-- <TitleDescription class="pt-5 mb-3"  title="Canais de Comunicação" />
                                    <div class="grid grid-cols-3 gap-y-[32px] px-2.5 gap-x-18 max-w-[326px] max-h-[198px] xl:justify-self-end">
                                        <span v-for="(campaignChannel, name) in campaignChannels" :key="name">
                                            <SocialMedia :description="campaignChannel.channel.name" :link="campaignChannel.link" textClasses="!text-primary" bodyClasses="bg-gray-100 hover:bg-gray-500">
                                                <Icon :name="campaignChannel.channel.name"/>
                                            </SocialMedia>
                                        </span>
                                    </div>

                                <TitleDescription title="Fale Conosco" description="Está com problemas? Deixa com a gente. Acesse a página de ajuda:" />
                                <Button @click="href('contact-form')" class="max-w-[182px] whitespace-nowrap">
                                    Fale Conosco
                                </Button> -->

                        </div>
                </div>
    </AuthenticatedLayout>

</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import { Head } from '@inertiajs/inertia-vue3';
import Heading from '@/Components/UI/Texts/Heading.vue'
import TitleDescription from '@/Components/TitleDescription.vue'
import Button from '@/Components/Button.vue'
import SocialMedia from '@/Components/UI/Icons/SocialMedia.vue'
import Icon from '@/Components/UI/Icons/Icon.vue'
import { formatDateHowItWorks } from '@/Helpers/masks.js'


export default {
    components:{
        AuthenticatedLayout,
        Head,
        Heading,
        TitleDescription,
        Button,
        SocialMedia,
        Icon,
    },

    props:{
        campaign: Object,
        campaignChannels: Object,
    },

    methods:{
        href(link){
            location.href = link;
        },

        period(){
            return `De ${formatDateHowItWorks(this.campaign.start)} até ${formatDateHowItWorks(this.campaign.end)}`
            // return `De ${this.campaign.start} até ${this.campaign.end}`
        },
        formatDateHowItWorks
    },
}
</script>
